<template>
  <v-container>
    <v-layout row wrap>
    </v-layout>
        <iframe :src="src" ref="pdf" target="_blank" pagelayout="landscape" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%" > 
        </iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
//import jsPDF from "jspdf";
import { mapActions } from "vuex";
import pdf from "vue-pdf";
import moment, { months } from 'moment';
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import SettingService from "@/services/SettingService";
import PayrollService from "@/services/PayrollService";
export default {
  components: {
    pdf
  },
  data() {
    return {
      doc: "",
      src: "",
      ltdName: " ",
      empcode: "",
      totalsalary :0,
      totalss:0,
      page:0,
      jsonData : [],
      income:"",
      incomeAmount:"",
      expenses:"",
      expensesAmount:"",
      space:"",
      spaceexpenses:"",
      spaceincome:"",
      data: null,
      pdfDocGen: null,
      years:0,
      names :"",
      IDcards :"",
      indexs:"",
      cumulativeSSs:"",
      last_salarys:"",
      monthsformat:"",
      header_table: [
        {
          text: "#"
        },
        {
          text: "รายการ"
        },
        {
          text: "หน่วยนับ"
        },
        {
          text: "จำนวน"
        }
      ]
    };
  },
  created() {
    this.doc = this.$route.params.docno;
    this.emp_code = this.$route.params.empcode;
    this.getCompany();
    
  },
  methods: {
     goto(path) {
      this.$router.push("/" + path);
    },
    back(){
      this.goto('payrolldoc/detail/'+this.doc);
    },
    async getPDFByEmpID() {
        let v = this;
      NProgress.start();
      try {
        let tmpResult = await PayrollService.getPayrollDetailByDocNo(this.doc);
       
        // gen items
        let rowIndex = 0;
        let index =0;
        let i = 0;
          console.log(tmpResult.data)
        tmpResult.data.forEach(element => {
            //console.log(element)
          index = index;
          rowIndex++;
              v.name = element.name.split('(')[0] ;//ชื่อพนักงาน
              if(element.idCard != null){
                v.IDcard = v.IDcardformat(element.idCard);//บัตรประชาชน
              }else{
                 v.IDcard = " ";
              }
              if(element.salary != null){
                 v.salarys = v.thousandSep(element.totalEarning);//เงินเดือน
              }else{
                v.salarys = v.thousandSep(0);
              }
              if(element.deductSS != null){
                v.deductSS = v.thousandSep(element.deductSS);//รายได้สุทธิ
              }else{
                v.deductSS =v.thousandSep(0);
              }
              v.month = moment(element.createDateTime).format('M');
              v.year = moment(element.createDateTime).format('YYYY');
              v.saveformat( v.month,v.year);
              v.salary =  element.totalEarning;
              v.ss = element.deductSS; 
              // console.log("name",v.name);
              // console.log("totalDeduct",element.totalDeduct);
              // console.log("total_balance",element.total_balance);
              
          if(element.totalEarning != 0 ){
            if(element.deductSS != 0){
                index++;
              i++;
              v.page++;
              v.ind = i+`\n`;
              v.names += v.name+`\n`;
              v.IDcards += v.IDcard+`\n`;
              v.last_salarys += v.salarys+`\n`;
              v.cumulativeSSs += v.deductSS +`\n`;
              v.indexs += v.ind;
              v.totalsalary += v.salary;
              v.totalss += v.ss;
            }
          
          }
          if(index == 10 ){
             v.jsonData.push(v.genSlipJson("before"));
              v.names = "";
              v.IDcards="";
              v.last_salarys =""
              v.cumulativeSSs = ""
              v.indexs = "";
              v.totalsalary = 0;
              index=0;
          }else if(i == tmpResult.data.length){
            v.jsonData.push(v.genSlipJson("before"));
          }
          else if(rowIndex == tmpResult.data.length){
            v.jsonData.push(v.genSlipJson("before"));
          }
          
           console.log("i",i)
           console.log("index",index)
        });
         
        this.createpdf();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    IDcardformat(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{1,13}/g);
      var match = matches && matches[0] || ''
      var parts = []

         parts.push(match.substring(0,1))
         parts.push(match.substring(1,5))
         parts.push(match.substring(5,10))
         parts.push(match.substring(10,12))
         parts.push(match.substring(12,13))
    

    if (parts.length) {
        return parts.join('-')
    } else {
        return value
    }
    },
    async getCompany() {
      NProgress.start();
      try {
        let tmpResult = await SettingService.getDataCompany();
        this.ltdName = tmpResult.data.content[0].companyname;
        this.getPDFByEmpID();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    saveformat(month,year){
         var m = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฏาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
         this.years = parseInt(year)+543;
         this.monthsformat = ""+m[month-1];
    },
    createpdf() {
      let v = this;
      var pdfMake = require("pdfmake/build/pdfmake.js");
      //pdfMake.setFonts(fonts);
      pdfMake.fonts = {
        Sarabun: {
          normal:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf",
          bold: "https://fonts.gstatic.com/s/sarabun/v12/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf",
          italics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf",
          bolditalics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf",
        },
      };
      // if (pdfMake.vfs == undefined) {
      //   var pdfFonts = require("pdfmake/build/vfs_fonts.js");
      //   pdfMake.vfs = pdfFonts.pdfMake.vfs;
      // }

      // pdfMake.fonts = {
      //   THSarabunNew: {
      //     normal: "THSarabunNew.ttf",
      //     bold: "THSarabunNew-Bold.ttf",
      //     italics: "THSarabunNew-Italic.ttf",
      //     bolditalics: "THSarabunNew-BoldItalic.ttf"
      //   },
      //   Roboto: {
      //     normal: "Roboto-Regular.ttf",
      //     bold: "Roboto-Medium.ttf",
      //     italics: "Roboto-Italic.ttf",
      //     bolditalics: "Roboto-MediumItalic.ttf"
      //   }
      // };

      let docDefinition = {
        content: this.jsonData,
        pageOrientation: 'landscape',
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 3]
          },
          subheader: {
            fontSize: 14,
            bold: true
          },
           subtext: {
            fontSize: 12,
            bold: true
          }
        },
        defaultStyle: {
          font: "Sarabun",
          fontSize: 14,
        }
      };

      this.pdfDocGen = pdfMake.createPdf(docDefinition);

      this.pdfDocGen.getDataUrl(data => {
        this.src = data;
      });
    },
    genSlipJson(param) {
      let jSonResult = [
           {
          columns: [   
           
            {
              text: "รายละเอียดการนำส่งเงินสมทบ",
              style: "header",
              alignment: "left",
             
            },
             {
              text: "สปส.1-10 ส่วนที่ 2",
              style: "subheader",
              alignment: "right",
            
            }
          ]
        },
        {
          columns: [
            {
              text: "สำหรับค่าจ้างเดือน..."+this.monthsformat+"...พ.ศ. .."+this.years+"..",
              style: "subheader",
              alignment: "left"
            },
            {
              width: 235,
              text: "แผ่นที่.......................ในจำนวน...........................แผ่น",
              style: "subheader",
              alignment: "left"
            }
          ]
        },
        {
          columns: [
            {
              text: "ชื่อสถานประกอบการ....."+this.ltdName+".....",
              style: "subheader",
              alignment: "left",
            },
            {
              width: 230,
              text: "เลขที่บัญชี",
              style: "subheader",
              alignment: "right",
               margin: [5,0,5,5], 
            },
            {
             
              width: 35,
              margin: [15,0,0,0],
              table: {
                widths: [5,5],
                heights: [10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" },
                  ],
                ]
              }, 
            },
            {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5, 0, 0, 0],
            },
            {
               width: 95,
               margin: [5,0,0,0],
              table: {
                widths: [5,5,5,5,5,5,5],
                heights: [10,10,10,10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" }
                  ],
                ]
              }, 
            },
             {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5,0,0,0],
            },
                        {
               width: 30,
               margin: [5,0,5,5],
              table: {
                widths: [5],
                heights: [10],
                headerRows: 1,
                body: [
                  [
                    { text: "" }
                  ],
                ]
              }, 
            },

          ]
        },
        {
          columns: [
           {
              width:580,
              text: "ลำดับที่สาขา",
              style: "subheader",
              alignment: "right",
               margin: [5, 0, 5, 5],
            },
            {
              style: "text",
              alignment: "right",
               width: 150,
                margin: [7, 0, 5, 5],
              table: {
                widths: [5,5,5,5,5,5],
                heights: [10,10,10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" }
                  ],
                ]
              },
               
            },
          ]
        },
        
        {
          columns: [
            {
              
              width: 750,
              table: {
                widths: [50,250,250,90,90],
                headerRows: 1,
                body: [
                  [
                    { text: "1",alignment: "center", style: "subheader", },
                    { text: "2",alignment: "center", style: "subheader",},
                    { text: "3",alignment: "center", style: "subheader", },
                    { text: "4",alignment: "center", style: "subheader", },
                    { text: "5",alignment: "center", style: "subheader", }
                  ],
                  [
                    { text: "ลำดับที่",alignment: "center", style: "subtext", },
                    { text: "เลขประจำตัวประชาชน"+"\n"+"(สำหรับคนต่างด้าวให้กรอกบัตรประกันสังคม)",alignment: "center", style: "subtext",},
                    { text: "คำนำหน้านาม-ชื่อ-ชื่อสกุล",alignment: "center", style: "subtext", },
                    { text: "ค่าจ้างที่จ่ายจริง",alignment: "center", style: "subtext", },
                    { text: "เงินสมทบผู้ประกันตน"+"\n"+"(ค่าจ้างที่ใช้ในการคำนวณ ไม่ต่ำกว่า 1,650 บาท และไม่เกิน 15,000 บาท)",alignment: "center", style: "subtext", }
                  ],
                  [
                    { text: this.indexs,alignment: "center", style: "subheader", },
                    { text: this.IDcards,alignment: "center", style: "subheader",},
                    { text: this.names,alignment: "left", style: "subheader",  margin: [15, 0, 5, 5],},
                    { text: this.last_salarys,alignment: "center", style: "subheader", },
                    { text: this.cumulativeSSs,alignment: "center", style: "subheader", }
                  ],

                
                ]
              },
              
            },
          
          ]
        },
         {
          columns: [
            {
               width: 577,
              text: "รวม",
                margin: [7, 5, 5, 5],
              style: "subheader",
              alignment: "right",
            },
            { 
             style: "text",
              alignment: "right",
              width: 750,
              table: {
                widths: [90,90],
                headerRows: 1,
                body: [
                  [
                    { text: this.thousandSep(this.totalsalary),alignment: "center", style: "subheader", },
                    { text: this.thousandSep(this.totalss),alignment: "center", style: "subheader",}
                  ],
                   [
                    { text: "",alignment: "center", style: "subheader", },
                    { text: "",alignment: "center", style: "subheader",}
                  ],
                ]
              },
               
            },
          ]
        },
        {
          columns: [
            {
              width: 1355,
              text: "ลงชื่อ............................................................นายจ้าง"+" \n"+
                    "(.................................................................)"+" \n"+

                    "ตำแหน่ง...................................................................."+" \n"+
                    "ยื่นแบบวันที่...............เดิอน.....................พ.ศ...............",
              margin: [7, 15, 5, 5],
              style: "subheader",
              alignment: "center",
            },
            
          ]
        },
        {
          columns: [
            {
              width: 576,
              text: "",
              style: "subheader",
              alignment: "left",
              pageBreak: param
            },
            { 
              width: 576,
              text: "",
              style: "subheader",
              alignment: "left",
              pageBreak: param
            },
          
          ]
        }
      ];
      return jSonResult;
    }
  },
};
</script>

<style lang="stylus" scoped>
.print {
  width: 100%;
  height :100%;


  table {
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }

  table th {
    border-bottom: 1px solid #F2F2F2;
  }
}
</style>
